export default __webpack_public_path__ + "static/media/tr.33b7e5b9.svg";